import { render, staticRenderFns } from "./AutomatedTasksActionsDoc.vue?vue&type=template&id=6530bd86"
import script from "./AutomatedTasksActionsDoc.vue?vue&type=script&lang=js"
export * from "./AutomatedTasksActionsDoc.vue?vue&type=script&lang=js"
import style0 from "./AutomatedTasksActionsDoc.vue?vue&type=style&index=0&id=6530bd86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports